import { PrimaryButton } from '@acko-tech/building-blocks.ui.button';
import usePermissionHook from 'hooks/usePermissionHook';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { getImageBasePath } from 'utils/generics';
import * as Styles from './styles';

const GSTCompleted = () => {
    const router = useRouter();
    const { getLobFromPermission, getPartnerIdFromPermission } =
        usePermissionHook();

    const onClick = () => {
        const url = `/${getLobFromPermission()}/${getPartnerIdFromPermission()}/dashboard`;
        router.push(url);
    };
    return (
        <Styles.Container>
            <Styles.BoldText>
                <Image
                    src={getImageBasePath('/images/Success.svg')}
                    width={40}
                    height={40}
                    style={{
                        marginTop: '4px',
                    }}
                />
                GST Updated Successfully
            </Styles.BoldText>
            <Styles.Banner>
                <Image
                    width={'250px'}
                    height={'250px'}
                    alt={''}
                    src={getImageBasePath('/images/Success.svg')}
                />
            </Styles.Banner>
            <Styles.Text>
                Your GST details are now verified and up to date.<br></br>
            </Styles.Text>
            <Styles.Text>
                You&apos;re all set to create new plans again
            </Styles.Text>
            <Styles.ButtonContainer>
                <PrimaryButton onClick={onClick}>Go to Home</PrimaryButton>
            </Styles.ButtonContainer>
        </Styles.Container>
    );
};

export default GSTCompleted;
